const appDomain = {
  local: "localhost:3001",
  development: "storytell-development.ai",
  production: "chief.bot",
};

const firebase = {
  development: "storytell-development-f686.firebaseapp.com",
  production: "storytell-production-1def.firebaseapp.com",
};

export const getAppDomain = (target) => {
  switch (target) {
    case "local":
      return appDomain.local;
    case "preview":
    case "development":
      return appDomain.development;
    default:
      return appDomain.production;
  }
};

export const getControlPlaneURL = (target) => {
  switch (target) {
    case "local":
      return "http://localhost:3443";
    case "development":
      return "https://api.storytell-development.ai";
    default:
      return "https://api.storytell.ai";
  }
};

export const getFirebaseDomain = (target) => {
  switch (target) {
    case "local":
    case "preview":
    case "development":
      return firebase.development;
    default:
      return firebase.production;
  }
};
